import { render, staticRenderFns } from "./PatientMonitoring.vue?vue&type=template&id=aefb8746&scoped=true&lang=pug"
import script from "./PatientMonitoring.vue?vue&type=script&lang=js"
export * from "./PatientMonitoring.vue?vue&type=script&lang=js"
import style0 from "./PatientMonitoring.vue?vue&type=style&index=0&id=aefb8746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefb8746",
  null
  
)

export default component.exports